import styled from 'styled-components';



export const ToolbarViewContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
